import { Validators, FormGroup, AbstractControl } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { IngresoPipe } from '../pipes/ingreso.pipe';
import { ENUM_CALLBACK_TRANFORMS } from './inputsHelpers';
import { _isNullOrUndefined } from './code-helper';

export function transformInputs(form: FormGroup, fields: string[], callback: ENUM_CALLBACK_TRANFORMS) {

  const transforms = {
    'transformInputToUpperCase': transformInputToUpperCase,
    'transformToCurrency': transformToCurrency
  }

  for (const field of fields) {
    const control = form.get(field)!;
    transforms[callback](control)
  }

}

export function setValidatorRequired(form: FormGroup, field: string) {
  const control = form.get(field)!;
  control.setValidators([Validators.required]);
  control.updateValueAndValidity();
}

export function clearValidatorsForField(form: FormGroup, field: string) {
  const control = form.get(field)!;
  control.clearValidators();
  control.updateValueAndValidity();
}

export function transformInputToUpperCase(control: AbstractControl) {

  control.valueChanges.pipe(debounceTime(300)).subscribe((txt: string) => {
    control.setValue(_isNullOrUndefined(txt) ? txt : txt.toUpperCase(), { emitEvent: false, });
  });
}

export function transformToCurrency(control: AbstractControl) {
  control.valueChanges.pipe(debounceTime(500)).subscribe((resp) => {
    const pipe = new IngresoPipe();
    const newTxt = pipe.transform(resp);
    control.setValue(newTxt, { emitEvent: false });
  });
}

